import React, { FC, FormEvent, useState } from 'react'
import { CustomLayer, PolygonStyle } from 'models/custom-layer'
import { Stack } from 'components/Stack'
import { Flex } from 'components/Flex'
import { ColorPicker } from 'components/ColorPicker'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import styles from '../../CustomLayerStylesDialog.module.scss'

type CustomLayerPolygonProps = {
  customLayer: CustomLayer
  onSubmit: (style: PolygonStyle) => void
  status: string
}

export const CustomLayerPolygon: FC<CustomLayerPolygonProps> = ({
  customLayer,
  onSubmit,
  status = 'idle',
}) => {
  const { t } = useTranslation()
  const [style, setStyle] = useState(customLayer.viz as PolygonStyle)

  const onFormSubmit = (event: FormEvent) => {
    event.preventDefault()
    onSubmit(style)
  }

  return (
    <form onSubmit={onFormSubmit}>
      <Stack space="medium">
        <Flex align="center">
          <Text component="span" weight="strong" className={styles.label}>
            {t('layer_style_dialog.form.color')}
          </Text>
          <ColorPicker
            value={style.paint['fill-color']}
            onChange={(color) =>
              setStyle({
                ...style,
                paint: { 'fill-color': color },
              })
            }
          />
        </Flex>

        <Button type="submit" full loading={status === 'loading'}>
          {t('layer_style_dialog.cta')}
        </Button>
      </Stack>
    </form>
  )
}

/* Line!

<Flex align="center">
            <Text component="span" weight="strong" className={styles.label}>
              {t('layer_style_dialog.form.stroke_width')}
            </Text>
            <Select
              options={STROKE_WIDTH_OPTIONS}
              value={buildSimpleOption(strokeWidth)}
              onChange={(option) =>
                setStrokeWidth(parseInt(option!.value! as string) as StrokeWidth)
              }
              className={styles.select}
            />
          </Flex>


*/
